import {  isAxiosError } from "axios";
import { SOMETHING_WENT_WRONG } from "../constant/errorConstants";
import toast from "react-hot-toast";

const parseDetails = (details: any): string | null => {
  if (!details) return null;
  if (typeof details === "string") {
    try {
      return parseDetails(JSON.parse(details));
    } catch {
      return null;
    }
  }
  if (typeof details === "object") {
    if (details?.error?.message) return details.error.message;
    if (details?.details) return parseDetails(details.details);
  }
  return null;
};

export const handleError = (error: any) => {
  if (error?.response?.data?.details) {
    const message = parseDetails(error?.response?.data?.details);
    return toast.error(message || SOMETHING_WENT_WRONG);
  }
  if (isAxiosError(error)) {
    return toast.error(
      error?.response?.data?.message ||
        error?.response?.data?.error?.message ||
        SOMETHING_WENT_WRONG,
    );
  }
  return toast.error(error?.response?.data?.message || error?.message || SOMETHING_WENT_WRONG);
};
